import React from "react";
import { Flex, Text } from "@chakra-ui/react";

export default ({ data, value }) => {
	return (
		<Flex alignItems={"flex-start"}>
			<Text fontSize={14} lineHeight={"16px"} mr="4px" whiteSpace={"nowrap"}>
				{data}:{" "}
			</Text>
			<Text fontWeight={600} lineHeight={"16px"} whiteSpace={"nowrap"}>
				{value}
			</Text>
		</Flex>
	);
};
